import { useContext } from 'react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { ReactComponent as CloseIcon } from 'assets/close-icon.svg';
import i18nContext from 'components/i18n-context';
import Button from 'uikit/Button/Button';
import Input from 'uikit/Input/Input';
import './PopUpUpdateSystemAccountIbanScheme.scss';

const PopUpUpdateSystemAccountIbanScheme = ({
  isLoading,
  currentIban,
  title,
  inputLabel,
  inputPlaceholder,
  onClose,
  onConfirm
}) => {
  const i18n = useContext(i18nContext);

  const form = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: {
      iban: currentIban ? currentIban : ''
    },
    validationSchema: Yup.object().shape({
      iban: Yup.string().required(i18n.getMessage('systemAccounts.updateIbanModal.validation.isRequired'))
    }),
    onSubmit: async (values) => {
      await onConfirm(values.iban);
    }
  });

  const { values, handleSubmit, errors, handleChange } = form;

  return (
    <div className={'scheme-wrapper scheme-update-system-account-iban-container'}>
      <div className={'scheme-update-system-account-iban-container-header'}>
        <h4>{title}</h4>
        <CloseIcon className={'scheme-update-system-account-iban-container-header-close-icon'} onClick={onClose} />
      </div>
      <form className={'scheme-update-system-account-iban-form'} onSubmit={handleSubmit}>
        <div className={'scheme-update-system-account-iban-form-inputs-wrapper'}>
          <Input
            className={'scheme-update-system-account-iban-input'}
            id={'iban'}
            name={'iban'}
            label={inputLabel}
            placeholder={inputPlaceholder}
            value={values.iban}
            onChange={handleChange}
            error={errors?.iban}
            disabled={isLoading}
          />
        </div>

        <div className={'scheme-update-system-account-iban-actions-wrapper'}>
          <Button
            className={'scheme-update-system-account-iban-button'}
            type={'outline'}
            onClick={onClose}
            isDisabled={isLoading}
          >
            {i18n.getMessage('systemAccounts.updateIbanModal.button.cancel')}
          </Button>
          <Button
            className={'scheme-update-system-account-iban-button'}
            roleType={'submit'}
            type={'primary'}
            isDisabled={isLoading}
          >
            {i18n.getMessage('systemAccounts.updateIbanModal.button.update')}
          </Button>
        </div>
      </form>
    </div>
  );
};

PopUpUpdateSystemAccountIbanScheme.propTypes = {
  isLoading: PropTypes.bool,
  currentIban: PropTypes.string,
  title: PropTypes.string,
  inputLabel: PropTypes.string,
  inputPlaceholder: PropTypes.string,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func
};

export default PopUpUpdateSystemAccountIbanScheme;
